import { useMutation } from '@tanstack/react-query';
import { api, call } from '../client';

/* Step 15: Tekansa staff across companies, and "Act as user". */

export function useStartActAs() {
  return useMutation({
    mutationFn: (body: {
      tenantId: string;
      userId: string;
      reason: string;
      minutes: 15 | 30 | 60;
    }) => call(api.POST('/v1/platform/act-as', { body })),
    // A different person's session now: start the app afresh.
    onSuccess: () => window.location.assign('/home'),
  });
}

export const stopActAs = () => call(api.POST('/v1/platform/act-as/stop'));

/** Back to your own session: Super Admin. */
export function useStopActAs() {
  return useMutation({
    mutationFn: stopActAs,
    onSettled: () => window.location.assign('/admin'),
  });
}
